import { RouteOptions } from '@fiverr-private/pathfinder';
import type { InspireDelivery } from '../../../types/inspire';

export enum InspireCardVariant {
    grid = 'grid',
    carousel = 'carousel',
}

export interface InspireCardProps {
    inspireDelivery: InspireDelivery;
    index: number;
    isTouch?: boolean;
    variant?: InspireCardVariant;
    cardHrefRouteOptions?: RouteOptions;
    onImpression?: (inspireDelivery: InspireDelivery, index: number) => void;
    onHrefClick?: (inspireDelivery: InspireDelivery, index: number) => void;
}
